// extracted by mini-css-extract-plugin
module.exports = {"SwitchWrapper":"SwitchSequence_SwitchWrapper__3BXtP","Description":"SwitchSequence_Description__S_hOT"};